// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cssload-container {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9000;
}

.cssload-speeding-wheel {
  content: "";
  display: block;
  position: absolute;
  left: 48%;
  top: 40%;
  width: 63px;
  height: 63px;
  margin: 0 auto;
  border: 10px solid #4850B3;
  border-radius: 50%;
  border-left-color: transparent;
  border-right-color: transparent;
  animation: cssload-spin 800ms infinite linear;
  -o-animation: cssload-spin 800ms infinite linear;
  -ms-animation: cssload-spin 800ms infinite linear;
  -webkit-animation: cssload-spin 800ms infinite linear;
  -moz-animation: cssload-spin 800ms infinite linear;
}

@keyframes cssload-spin {
  100% {
    transform: rotate(360deg);
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/spinner/spinner.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,0CAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;EACA,kBAAA;EACA,8BAAA;EACA,+BAAA;EACA,6CAAA;EACA,gDAAA;EACA,iDAAA;EACA,qDAAA;EACA,kDAAA;AACF;;AAEA;EACE;IACE,yBAAA;IACA,yBAAA;EACF;AACF","sourcesContent":[".cssload-container {\r\n  position: fixed;\r\n  width: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  background-color: rgba(255, 255, 255, 0.7);\r\n  z-index: 9000;\r\n}\r\n\r\n.cssload-speeding-wheel {\r\n  content: \"\";\r\n  display: block;\r\n  position: absolute;\r\n  left: 48%;\r\n  top: 40%;\r\n  width: 63px;\r\n  height: 63px;\r\n  margin: 0 auto;\r\n  border: 10px solid #4850B3;\r\n  border-radius: 50%;\r\n  border-left-color: transparent;\r\n  border-right-color: transparent;\r\n  animation: cssload-spin 800ms infinite linear;\r\n  -o-animation: cssload-spin 800ms infinite linear;\r\n  -ms-animation: cssload-spin 800ms infinite linear;\r\n  -webkit-animation: cssload-spin 800ms infinite linear;\r\n  -moz-animation: cssload-spin 800ms infinite linear;\r\n}\r\n\r\n@keyframes cssload-spin {\r\n  100% {\r\n    transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@-o-keyframes cssload-spin {\r\n  100% {\r\n    -o-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@-ms-keyframes cssload-spin {\r\n  100% {\r\n    -ms-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes cssload-spin {\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@-moz-keyframes cssload-spin {\r\n  100% {\r\n    -moz-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
